<ol>
  <li *ngFor="let message of data">{{message}}</li>
</ol>
